<template>
    <div class="income-total-base-table box">
        <table class="income-total-base-table__table income-total-base-table__table_striped income-total-base-table__table_hover">
            <col class="income-total-base-table__column"
                v-for="column in columns"
                :key="column.id"
                :class="`income-total-base-table__column_${column.id}`"
            >
            <thead>
                <income-total-base-table-head-row :columns="columns" />
            </thead>
            <tbody>
                <income-total-base-table-body-row
                    v-if="totalRow"
                    class="income-total-base-table__row_pinned"
                    :columns="columns"
                    :row="totalRow"
                />
                <income-total-base-table-body-row
                    v-for="row in rows"
                    :key="row.id"
                    :columns="columns"
                    :row="row"
                />
            </tbody>
        </table>
    </div>
</template>

<script>
    import IncomeTotalBaseTableHeadRow from "./IncomeTotalBaseTableHeadRow";
    import IncomeTotalBaseTableBodyRow from "./IncomeTotalBaseTableBodyRow";

    export default {
        name: "IncomeTotalBaseTable",
        components: {
            IncomeTotalBaseTableHeadRow,
            IncomeTotalBaseTableBodyRow,
        },
        props: {
            columns: {
                type: Array,
                required: true
            },
            totalRow: {
                type: Object,
            },
            rows: {
                type: Array,
                required: true
            }
        },
    };
</script>

<style lang="scss">
    .income-total-base-table {
        padding: 16px;
        overflow-x: auto;
    }
    .income-total-base-table__table {
        width: 100%;
    }
    .income-total-base-table__column {
        &_title {
            width: 25%;
        }

        &_dish_group {
            width: 18%;
        }
    }
    .income-total-base-table__row {
        &_body {
            .income-total-base-table__table_striped &:nth-of-type(odd) {
                background-color: $background-gray-primary;
            }

            .income-total-base-table__table_hover &:hover {
                background-color: $gray-form;
            }
        }

        &_pinned {
            background-color: $gray-form !important;
        }
    }
    .income-total-base-table__cell {
        font-size: 20px;
        padding: 12px 8px;

        &_head {
            padding: 8px;
            white-space: nowrap;
        }

        &_sortable {
            cursor: pointer;
        }

        &_title {
            font-weight: bold;
        }

        &_tar {
            text-align: right;
        }
    }
    .income-total-base-table__cell-content {
        display: grid;
        grid-gap: 5px;

        &_columns {
            grid-auto-flow: column;
            align-items: center;

            &.income-total-base-table__cell-content_left {
                justify-content: start;
            }

            &.income-total-base-table__cell-content_right {
                justify-content: end;
                text-align: right;
            }
        }

        &_rows {
            grid-auto-flow: row;

            &.income-total-base-table__cell-content_left {
                justify-items: start;
            }

            &.income-total-base-table__cell-content_right {
                justify-items: end;
            }
        }
    }
    .income-total-base-table__value {
        &_icon {
            width: 16px;
            height: 16px;
        }
    }
</style>
